import React, { Component } from "react";
// import AppNavbar from "./components/AppNavbar";
// import ShoppingList from "./components/ShoppingList";
// import ItemModal from "./components/ItemModal";
// import DashboardViewer from "./components/DashboardViewer";
// import { Container } from "reactstrap";
// import { checkAuthentification } from "./actions/authActions";
import { Provider } from "react-redux";
import store from "./store";
// import { loadUser } from "./actions/authActions";
// import { BrowserRouter as Router } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import "./fonts/Poppins-Regular.ttf";
import "./fonts/Poppins-Bold.ttf";
import "./fonts/Poppins-ExtraBold.ttf";
// import "./index.css";
// import history from "./history";
// import { connect } from "react-redux";
// import PropTypes from "prop-types";
import AppStore from "./AppStore";
// import WebSocketProvider from "./WebSocket";
import WebsocketContextProvider from "./WebsocketContext";
import { MsalProvider } from "@azure/msal-react";
import "./components/subcomponents/Calendar.css";

// const basicStoreContext = React.createContext();

class App extends Component {
  componentDidMount() {
    // store.dispatch(loadUser());
    // this.props.checkAuthentification();
  }

  // static propTypes = {
  //   checkAuthentification: PropTypes.func.isRequired,
  //   authentificated: PropTypes.object.isRequired,
  // };

  render() {
    return (
      // <Provider store={store} context={basicStoreContext}> j
      <MsalProvider instance={this.props.msalInstance}>
        <Provider store={store}>
          <WebsocketContextProvider>
            {console.log(window.location.href)}
            <PayPalScriptProvider
            options={{
              locale: "en_US",
              currency: "EUR",
              clientId:
                // "AbsyMMax6sPtzDZDosoAwEkMvzJNimNRX6NnEYgI_9WfQjeqJoFnlw_lLQlT0-m6cUtI6fGWUfi4rS7i", // test !!!!
                "AQYWkzqV2IFpuR1miIUGWfDPynwUrYvMRRd_n6MLbr9Z-rmtdUqEzETrlrqDkbGYGXUocHlkbLtYrH7l", //live !!!!
            }}
          >
            <div className="App">
              {console.log}
              <AppStore />
            </div>
            </PayPalScriptProvider>
          </WebsocketContextProvider>
        </Provider>
      </MsalProvider>
    );
  }
}

// const mapStateToProps = (state) => ({
//   authentificated: state.auth.authentificated,
//   // this is props so add prop type
// });

// export default connect(mapStateToProps, {
//   checkAuthentification,
// })(App);

export default App;
